module.exports = __webpack_public_path__ + "si.svg?a6c3b9539ecbf7e144fd9c6769cd5b77";